import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Modal from 'react-modal'
import SlidingPane from 'react-sliding-pane'
import { Container } from 'reactstrap'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

import Footer from '../components/footer'

import onRouteUpdate from '../../gatsby-browser'

import WhoWeAre from '../components/who-we-are'
import OurStory from '../components/our-story'
import WhatWeDo from '../components/what-we-do'
import WhatYouCanDo from '../components/what-you-can-do'
import OurTrustees from '../components/our-trustees'
import OurSupporters from '../components/our-supporters'
import OurNews from '../components/our-news'
import ContactUs from '../components/contact-us'

import 'react-sliding-pane/dist/react-sliding-pane.css';
import './style.css'

class pageTemplate extends Component {

    constructor(props) {
        super(props);

        this.state = {
            colour: '',
            isPaneOpen: false,
            isPaneOpenLeft: false
        }

    }

    componentDidMount() {
        Modal.setAppElement(this.el)
    }

    render() {

        onRouteUpdate

        let thisSlug = `/${this.props.data.contentfulBlog.slug}`

        const {
            title,
            slug,
            content,
            backgroundImage,
            pageColour,
            slidingPanelTitle,
            slidingPanelIntro,
            slidingPanelImage,
            slidingPanelLeft,
            slidingPanelRight,
            metaDescription,
            openGraphTitle,
            openGraphDescription,
            openGraphUrl,
            openGraphImage,
            twitterCard,
            twitterSite,
            twitterTitle,
            twitterDescription,
            twitterImage,
            youTubeVideos

        } = this.props.data.contentfulBlog
        let bgImg = backgroundImage.resolutions.src
        let bgImgSrc = {
            background: `url(${bgImg})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center right',
        }

        const modalStyle = { overlay: { zIndex: 10 } }

        return (

            <div className={`section ${pageColour}`} style={bgImgSrc} ref={ref => this.el = ref} >

                <div className={"dots " + pageColour} />

                <Helmet title={`JBVC Foundation | ${title}`}>

                    {metaDescription && <meta name="description" content={`${metaDescription}`} />}
                    {metaDescription && <meta property="og:title" content={`${openGraphTitle}`} />}
                    {metaDescription && <meta property="og:description" content={`${openGraphDescription}`} />}
                    {metaDescription && <meta property="og:url" content={`${openGraphUrl}`} />}
                    {metaDescription && <meta property="og:image" content={`${openGraphImage.resolutions.src}`} />}
                    {metaDescription && <meta name="twitter:card" content={`${twitterCard.resolutions.src}`} />}
                    {metaDescription && <meta name="twitter:site" content={`${twitterSite}`} />}
                    {metaDescription && <meta name="twitter:title" content={`${twitterTitle}`} />}
                    {metaDescription && <meta name="twitter:description" content={`${twitterDescription}`} />}
                    {metaDescription && <meta name="twitter:image" content={`${twitterImage.resolutions.src}`} />}

                </Helmet>

                <div className={`content ${this.props.data.contentfulBlog.slug}`} style={this.state.isPaneOpenLeft ? { opacity: '0' } : { opacity: '1' }} >
                    <h1 className={pageColour}>{title}</h1>
                    <hr className={pageColour} />
                    <div className="inner" dangerouslySetInnerHTML={{ __html: content.childMarkdownRemark.html }} />
                    <hr className={pageColour} />

                    {slug === 'contact-us' ?
                        <div className="readMore" onClick={() => this.setState({ isPaneOpenLeft: true })}>
                            Contact form <span className="green">&amp;</span> Newsletter sign up
                            <div className={`chevron ${pageColour}`} />
                            <div className={`chevron ${pageColour}`} />
                        </div>
                        : slug === 'what-we-do' ? <div></div> :
                            <div className="readMore" onClick={() => this.setState({ isPaneOpenLeft: true })}>
                                Read more
                                <div className={`chevron ${pageColour}`} />
                                <div className={`chevron ${pageColour}`} />
                            </div>
                    }
                    {/*
                        slug === 'who-we-are' || slug === 'what-you-can-do' ?
                            <div className={`donateNow ${pageColour}`}>
                                <OutboundLink href="https://www.justgiving.com/jbvcfoundation" target='_blank'>Donate Now</OutboundLink>
                                <div className={`chevron ${pageColour}`} />
                                <div className={`chevron ${pageColour}`} />
                            </div>
                            : ""
                    */}
                </div>
                <SlidingPane
                    className={`slidingPanel ${pageColour} ${slug}`}
                    style={modalStyle}
                    isOpen={this.state.isPaneOpenLeft}
                    title={slidingPanelTitle}
                    from='left'
                    width='70%'
                    onRequestClose={() => this.setState({ isPaneOpenLeft: false })}>

                    <Container style={this.state.isPaneOpenLeft ? { opacity: '1', transition: 'all 1s ease', zIndex: '2' } : { opacity: '0', transition: 'all 1s ease', zIndex: '2' }}>

                        {slug === 'who-we-are' && <WhoWeAre intro={slidingPanelIntro.childMarkdownRemark.html} image={slidingPanelImage.resolutions.src} leftCol={slidingPanelLeft.childMarkdownRemark.html}
                            rightCol={slidingPanelRight.childMarkdownRemark.html} />}
                        {slug === 'our-story' && <OurStory intro={slidingPanelIntro.childMarkdownRemark.html} leftCol={slidingPanelLeft.childMarkdownRemark.html} />}
                        {slug === 'what-we-do' && <WhatWeDo intro={slidingPanelIntro.childMarkdownRemark.html} leftCol={slidingPanelLeft.childMarkdownRemark.html} rightCol={slidingPanelRight.childMarkdownRemark.html} youTubeVideos={youTubeVideos} />}
                        {slug === 'what-you-can-do' && <WhatYouCanDo intro={slidingPanelIntro.childMarkdownRemark.html} leftCol={slidingPanelLeft.childMarkdownRemark.html} rightCol={slidingPanelRight.childMarkdownRemark.html} />}
                        {slug === 'our-trustees' && <OurTrustees intro={slidingPanelIntro.childMarkdownRemark.html} leftCol={slidingPanelLeft.childMarkdownRemark.html} />}
                        {slug === 'our-supporters' && <OurSupporters intro={slidingPanelIntro.childMarkdownRemark.html} leftCol={slidingPanelLeft.childMarkdownRemark.html} />}
                        {slug === 'our-news' && <OurNews intro={slidingPanelIntro.childMarkdownRemark.html} leftCol={slidingPanelLeft.childMarkdownRemark.html} />}
                        {slug === 'contact-us' && <ContactUs intro={slidingPanelIntro.childMarkdownRemark.html} leftCol={slidingPanelLeft.childMarkdownRemark.html} />}


                    </Container>
                </SlidingPane>
                <Footer />
            </div>
        )
    }
}

pageTemplate.propTypes = {
    data: PropTypes.object.isRequired
}

export default pageTemplate

export const pageQuery = graphql`
    query blogPostQuery($slug: String!) {
        contentfulBlog(slug: {eq: $slug}) {
            title
            slug
            content{
                childMarkdownRemark{
                    html
                }
            }
            backgroundImage {
                resolutions(width: 2560) {
                  width
                  height
                  src
                  srcSet
                }
            }
            pageColour
            slidingPanelTitle
            slidingPanelIntro{
                childMarkdownRemark{
                    html
                }
            }
            slidingPanelImage {
                resolutions(width: 2560) {
                    width
                    height
                    src
                    srcSet
                }
            }
            slidingPanelLeft{
                childMarkdownRemark{
                    html
                }
            }
            slidingPanelRight{
                childMarkdownRemark{
                    html
                }
            }
            metaDescription
            openGraphTitle
            openGraphDescription
            openGraphUrl
            openGraphImage {
                resolutions(width: 500) {
                    src
                }
            }
            twitterCard {
                resolutions(width: 500) {
                    src
                }
            }
            twitterSite
            twitterTitle
            twitterDescription
            twitterImage {
                resolutions(width: 500) {
                    src
                }
            }
            youTubeVideos{
                id
                key
                value
            }
        }
    }
`



// WEBPACK FOOTER //
// ./src/templates/page.js